<template>
  <div
    class="card__body"
    :class="{'card__body--padded': padded}"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      padded: {
        type: Boolean,
        default: true
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .card {
    &__body {
      flex: 1;
      background: $white;
      border-radius: 0 0 4px 4px;
      box-shadow: 0 2px 5px 0 rgba($bali, 0.25);
      &--padded {
        padding: $card-padding-y-sm $card-padding-x-sm;
        @include minpoint(tablet) {
          padding: $card-padding-y $card-padding-x;
        }
      }
    }
  }
</style>
